import { useHistory } from 'react-router-dom';

const useRoute = () => {
  const history = useHistory();

  const handlePage = data => {
    history.push({
      pathname: '/definicion/departamento',
      state: {
        department: data[3],
        isComingFrom: '/definicion/seleccion/departamento',
      },
    });
  };

  return { handlePage };
};

export default useRoute;
